// Константы для набора компетенций
export const MAX_COMPETENCE_SET = 3; // Максимальное количество компетенций в наборе
